// Client logos for the homepage / newsroom marquee.
// Order and artwork follow the Figma frame "Frame 889844" (node 11695:4312):
// https://www.figma.com/design/jXGGGzr53ecewpzQ8ytprr/1.-NowPurchase-Website?node-id=11695-4312
//
// Each PNG was exported from that frame and trimmed of its transparent padding.
// `width` is the logo's designed width in the frame; every box is 60px tall.
// Rendering at that exact box with object-fit: contain reproduces the design,
// including the few logos the frame scales down to fit a narrower box.
const LANDING_PREFIX = "https://images.nowpurchase.com/landing/";

export const CLIENT_LOGOS = [
  { name: "Diva Ravi Group", src: `${LANDING_PREFIX}20260827160651_DivaRaviGroup.png`, width: 104 },
  { name: "Titagarh", src: `${LANDING_PREFIX}20260827160651_Titagarh.png`, width: 58 },
  { name: "Brakes India", src: `${LANDING_PREFIX}20260827160609_BrakesIndia.png`, width: 204 },
  { name: "Tata Metaliks", src: `${LANDING_PREFIX}20260827160652_TataMetaliks.png`, width: 120 },
  { name: "Crescent Foundry", src: `${LANDING_PREFIX}20260827160652_CrescentFoundry.png`, width: 196.438 },
  { name: "Shyam Steel", src: `${LANDING_PREFIX}20260827160653_ShyamSteel.png`, width: 83 },
  { name: "RB Agarwalla", src: `${LANDING_PREFIX}20260827160653_RBAgarwalla.png`, width: 93 },
  { name: "Mantri Metallics", src: `${LANDING_PREFIX}20260827160653_MantriMetallics.png`, width: 295 },
  { name: "Jupiter", src: `${LANDING_PREFIX}20260827160654_Jupiter.png`, width: 48 },
  { name: "NIPHA", src: `${LANDING_PREFIX}20260827160654_Nipha.png`, width: 304.186 },
  { name: "Shanti Foumach", src: `${LANDING_PREFIX}20260827160655_ShantiFoumach.png`, width: 191 },
  { name: "Kejriwal Castings", src: `${LANDING_PREFIX}20260827160655_KejriwalCastings.png`, width: 78 },
  { name: "Synergy Green", src: `${LANDING_PREFIX}20260827160656_SynergyGreen.png`, width: 51 },
  { name: "Ramkrishna Forgings", src: `${LANDING_PREFIX}20260827160656_RamkrishnaForgings.png`, width: 233 },
  { name: "SteelCast", src: `${LANDING_PREFIX}20260827160657_SteelCast.png`, width: 122 },
  { name: "JSW", src: `${LANDING_PREFIX}20260827160657_JSW.png`, width: 123 },
  { name: "Sound Castings", src: `${LANDING_PREFIX}20260827160658_SoundCastings.png`, width: 236 },
  { name: "Craftsman Automation", src: `${LANDING_PREFIX}20260827160658_CraftsmanAutomation.png`, width: 194 },
  { name: "Kores", src: `${LANDING_PREFIX}20260827160658_Kores.png`, width: 192.787 },
  { name: "Sandfits", src: `${LANDING_PREFIX}20260827160659_Sandfits.png`, width: 170 },
  { name: "Aqua Group", src: `${LANDING_PREFIX}20260827160659_AquaGroup.png`, width: 181.818 },
];
